'use strict';

Object.defineProperty(exports, "__esModule", {
   value: true
});
/* eslint-disable import/prefer-default-export */

var FBUY_COOKIE_NAME = exports.FBUY_COOKIE_NAME = 'friendbuy_referral_code';
var FBUY_QUERY_PARAM = exports.FBUY_QUERY_PARAM = 'fbuy_ref_code';

var friendbuyCode = exports.friendbuyCode = function friendbuyCode(state) {
   return state.request.query[FBUY_QUERY_PARAM] || state.request.cookies[FBUY_COOKIE_NAME];
};